import { clientPortalRequest } from "./clientPortalFetch";

export function getGoogleAnalyticsSettings(clientViewId) {
  return clientPortalRequest(`/views/${clientViewId}/integrations/google-analytics`);
}

export function updateGoogleAnalyticsSettings(clientViewId, payload) {
  return clientPortalRequest(`/views/${clientViewId}/integrations/google-analytics`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}
